<template>
  <ClientOnly>
    <NuxtIcon :name="name" class="block shrink-0" filled />
  </ClientOnly>
</template>

<script setup lang="ts">
type Props = {
  name: string;
};

defineProps<Props>();
</script>

<style scoped lang="scss">
.nuxt-icon :deep(svg) {
  @apply w-full h-full m-0;
}
</style>
